export default "__VITE_ASSET__46c0dbfd__"